import { __decorate, __metadata } from "tslib";
import { IdItemModel, Expose, EditorDefinition, CrudEndpoints, ItemModelDefinition, ModelId, Structure, IsString, IsOptional } from '@core/shared/model';
import { UseRestraints } from '@core/shared/restraints';
import { MediaAssetRestraints } from "./media-asset.restraints";
import { MediaAssetMappingItem } from './media-asset-mapping.item';
let MediaAssetItem = /*#__PURE__*/(() => {
  let MediaAssetItem = class MediaAssetItem extends IdItemModel {
    toString() {
      return "MediaAsset " + this.id;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], MediaAssetItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], MediaAssetItem.prototype, "ownerId", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], MediaAssetItem.prototype, "updateDate", void 0);
  __decorate([Expose(), Structure(Array, () => MediaAssetMappingItem), __metadata("design:type", Array)], MediaAssetItem.prototype, "usage", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], MediaAssetItem.prototype, "id", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MediaAssetItem.prototype, "hostId", void 0);
  __decorate([Expose(), IsString(), __metadata("design:type", String)], MediaAssetItem.prototype, "name", void 0);
  __decorate([Expose(), IsString(), IsOptional(), __metadata("design:type", String)], MediaAssetItem.prototype, "description", void 0);
  __decorate([Expose(), __metadata("design:type", Array)], MediaAssetItem.prototype, "subtitles", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MediaAssetItem.prototype, "directUrl", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MediaAssetItem.prototype, "type", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MediaAssetItem.prototype, "provider", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], MediaAssetItem.prototype, "providerData", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], MediaAssetItem.prototype, "ready", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], MediaAssetItem.prototype, "meta", void 0);
  MediaAssetItem = __decorate([EditorDefinition({
    name: true,
    description: true
  }, {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/media/assets'
  }), ItemModelDefinition({
    texts: {}
  }), UseRestraints(MediaAssetRestraints), ModelId("MediaAssetItem") // auto-generated by generate-model-ids
  ], MediaAssetItem);
  return MediaAssetItem;
})();
export { MediaAssetItem };